module.exports = __webpack_public_path__ + "static/character-2-79d6cc4f4e788bd9fd64b64ce0762a85.svg";